// Anciennes adresses WordPress → nouvelles pages (301 côté client + stubs pré-rendus avec meta refresh)
export const EXPLICIT_REDIRECTS = {
  "/nos-realisations": "/realisations",
  "/realisations": "/realisations",
  "/nos-services": "/services",
  "/renovation": "/services",
  "/construction": "/services",
  "/toiture": "/services",
  "/plomberie-chauffage": "/services",
  "/electricite": "/services",
  "/terrassement": "/services",
  "/a-propos-de-nous": "/a-propos",
  "/qui-sommes-nous": "/a-propos",
  "/contactez-nous": "/contact",
  "/nous-contacter": "/contact",
  "/devis": "/demande-devis",
  "/demande-de-devis": "/demande-devis",
  "/devis-gratuit": "/demande-devis",
  "/mentions-legales-politique-de-confidentialite": "/mentions-legales",
  "/politique-de-confidentialite": "/mentions-legales",
  "/blog": "/",
  "/actualites": "/",
  "/feed": "/",
};

// Chemins WordPress techniques : on affiche la 404 (pas de redirection)
const GONE_PREFIXES = ["/wp-content", "/wp-includes", "/wp-admin", "/wp-login.php", "/xmlrpc.php", "/wp-json"];

const KEYWORDS = [
  ["realisation", "/realisations"],
  ["service", "/services"],
  ["contact", "/contact"],
  ["devis", "/demande-devis"],
  ["propos", "/a-propos"],
  ["mention", "/mentions-legales"],
  ["confidentialit", "/mentions-legales"],
];

export function normalizePath(pathname) {
  let p = (pathname || "/").toLowerCase();
  if (p.length > 1 && p.endsWith("/")) p = p.replace(/\/+$/, "");
  return p || "/";
}

export function resolveRedirect(pathname, search = "") {
  const p = normalizePath(pathname);
  if (GONE_PREFIXES.some(g => p.startsWith(g))) return null;
  if (EXPLICIT_REDIRECTS[p]) return EXPLICIT_REDIRECTS[p];
  if (p.startsWith("/category/") || p.startsWith("/tag/") || p.startsWith("/author/")) return "/";
  if (p === "/" && /[?&]s=/.test(search)) return "/";
  const hit = KEYWORDS.find(([kw]) => p.includes(kw));
  return hit ? hit[1] : null;
}
